import type { TasksAndDecisionsPluginOptions } from '@atlaskit/editor-plugin-tasks-and-decisions';

interface Props {
	options: Pick<
		TasksAndDecisionsPluginOptions,
		| 'taskDecisionProvider'
		| 'hasEditPermission'
		| 'requestToEditContent'
		| 'hasRequestedEditPermission'
	>;
}

export function tasksAndDecisionsPluginOptions({ options }: Props): TasksAndDecisionsPluginOptions {
	return {
		allowNestedTasks: true,
		consumeTabs: true,
		useLongPressSelection: false,
		taskDecisionProvider: options.taskDecisionProvider,
		hasEditPermission: options.hasEditPermission,
		requestToEditContent: options.requestToEditContent,
		hasRequestedEditPermission: options.hasRequestedEditPermission,
	};
}
